import { Incarico } from './incarico';
import { Model } from './model';
import { User } from './user';

export class Annotazione extends Model {
  static apiUrl: string = "annotazioni";

  titolo: string;
  testo: string;

  incarico: Incarico;
  user: User;


  deserialize(input: any): Annotazione {
    let retV: Annotazione = new Annotazione();

    retV = super.deserialize(input) as Annotazione;

    if (input?.incarico) {
      retV.incarico = new Incarico().deserialize(input.incarico);
    }
    if (input?.user) {
      retV.user = new User().deserialize(input.user);
    }


    return retV;
  }

  getHumanIdentifier() {
    return this.titolo || this.testo?.substring(0, 20);
  }
}
